import axios from "axios";
import { getUuid } from "utils/Uuid";

// Create an axios instance
const api = axios.create({
  //baseURL: 'https://api.example.com', // Replace with your API's base URL
  timeout: 200000, // Optional: Request timeout in milliseconds
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-scan-trace-id": getUuid(),
  },
});

// Optional: Set up interceptors
api.interceptors.request.use(
  (config) => {
    // Example: Add auth token if available
    const token = localStorage.getItem("AUTH_TOKEN");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API error:", error);
    // Handle global error responses here (like redirecting to login on 401)
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access
    }
    return Promise.reject(error);
  }
);

export default api;
